import i18n from "../i18n";

export const formatter = (lang) => new Intl.NumberFormat(`${ lang ? lang : i18n.language ? i18n.language :'en' }-EG`, {
    style: 'currency',
    currency: 'EGP'
  });